module.exports = __webpack_public_path__ + "static/media/claraLogo.d970859e.png";